// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__3MQ5O"};